import { experimental_extendTheme as extendTheme } from '@mui/material/styles';
import { lightTheme, darkTheme } from './theme';
import { customShadows as buildCustomShadows } from './core/custom-shadows';
import { COLORS } from './core/palette';

// Build a CSS Vars-enabled theme so `theme.vars.palette.*` is available
export const variableTheme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        ...lightTheme.palette,
        Button: COLORS.light.button as any,
        // MUI X DataGrid's own root-border logic (getBorderColor in
        // GridRootStyles.js) reads theme.vars.palette.TableCell.border
        // directly, bypassing `divider`, whenever theme.vars exists (it does
        // here). Left unset, MUI falls back to its own stock default, which
        // reads as a mismatched, off-brand color against this app's dark
        // navy surfaces — pin it to the same divider token as everything else.
        TableCell: { border: lightTheme.palette.divider } as any,
      } as any,
    },
    dark: {
      palette: {
        ...darkTheme.palette,
        Button: COLORS.dark.button as any,
        TableCell: { border: darkTheme.palette.divider } as any,
      } as any,
    },
  },
  // Use light theme structure for shared options
  shape: lightTheme.shape,
  spacing: lightTheme.spacing,
  typography: lightTheme.typography,
  components: lightTheme.components,
  // Preserve custom fields
  customShadows: buildCustomShadows('light'),
  charts: lightTheme.charts,
  sidebar: lightTheme.sidebar,
  design: lightTheme.design,
  journeyBuilder: {
    ...lightTheme.journeyBuilder,
    edge: {
      ...lightTheme.journeyBuilder.edge,
      strokeColor: 'var(--mui-palette-text-primary)',
    },
  },
});

export default variableTheme;

